import { IController } from 'angular';
import * as _ from 'lodash';
import { ImUser } from 'Src/ng2/shared/services/im-models/im-user';

export class SideNavMenuCtrl implements IController {
  static $inject = ['$scope', '$state', '$window', 'NavService', '$location', 'ObjectCache', 'SpinnerModal', 'ImUser'];

  // Bindings
  private SideNavOption;
  private currentUser;

  constructor(
    private $scope,
    private $state,
    private $window,
    private NavService,
    private $location,
    private ObjectCache,
    private SpinnerModal,
    private imUser: ImUser,
  ) {}

  $onInit() {
    // SideNav Config
    this.SideNavOption = {
      HOME: {
        humanName: 'Home',
        icon: 'home',
        isActiveState: 'main.school.home',
        goState: 'main.school.home',
        isRestricted: null,
      },
      STUDENT_PROFILE: {
        humanName: 'Student Profile',
        icon: 'people',
        isActiveState: 'main.school.single-student',
        goState: 'main.school.single-student-select-first-student',
        isRestricted: null,
      },
      STUDENT_GRID: {
        humanName: 'Student Grid',
        icon: 'grid_on',
        isActiveState: 'main.school.new-sdc.default-sdc.grid',
        goState: 'main.school.new-sdc.default-sdc.grid',
        isRestricted: null,
      },
      MY_SUPPORTS: {
        humanName: 'My Supports',
        icon: 'assignment',
        isActiveState: 'main.school.my-supports',
        goState: 'main.school.my-supports',
        isRestricted: null,
      },
      AFFINITY_SITE: {
        humanName: 'Affinity Site',
        icon: 'web',
        isActiveState: null,
        goState: null,
        isRestricted: false,
      },
      CURRICULUM_SITE: {
        humanName: 'Curriculum Site',
        icon: 'web',
        isActiveState: null,
        goState: null,
        isRestricted: false,
      },
      CLOUDLAB_SITE: {
        humanName: 'CloudLab Site',
        icon: 'web',
        isActiveState: null,
        goState: null,
        isRestricted: false,
      },
      BACK_TO_DISTRICT_SCHOOLS: {
        humanName: 'Back to District Tools',
        icon: 'keyboard_backspace',
        isActiveState: null,
        goState: 'main.home',
        isRestricted: null,
      },
    };

    // Assign isRestricted values to SideNavOption
    _.each(this.SideNavOption, (v: any) => {
      if (v.isRestricted === null) {
        v.isRestricted = !this.imUser.canAccessState(this.currentUser, v.goState);
      }
    });

    this.$scope.SideNavOption = this.SideNavOption;

    /*
    manually calls state transition here instead of relying on ui-sref. necessary.
    goThere() is necessary due to a ui-router issue that is documented here:
    https://github.com/angular-ui/ui-router/issues/395#issuecomment-56884667

    */

    this.$scope.goState = (state, params) => {
      // if state is already loaded, just close sidenav again
      if (state === this.$state.current.name) {
        this.NavService.closeNav('left');
      } else {
        this.SpinnerModal.activateSpinner('Loading...');
        this.NavService.closeNav('left');
        this.$state.go(state, _.extend(this.$state.params, params));
      }
    };

    this.$scope.externalUrls = {
      affinity: () => {
        this.$window.open('http://affinity.newvisions.org/', '_blank');
      },
      curriculum: () => {
        this.$window.open('http://www.newvisions.org/pages/curriculum-and-instruction', '_blank');
      },
      cloudLab: () => {
        this.$window.open('http://cloudlab.newvisions.org/', '_blank');
      },
    };
  }

  // Functions

  /*
      highlights currently selected state
    */

  isActive = stateName => {
    return stateName === this.$state.current.name;
  };

  // Changing ag-grid filters does not update $state.params or $stateParams
  // $location service does get updated with query params
  filterParam = () => {
    return { filter: this.$location.$$search.filter || this.ObjectCache.cacheObject({}) };
  };

  isClusterUser = () => {
    if (this.imUser.isEmpty(this.currentUser)) {
      return false;
    }
    return this.imUser.isClusterUser(this.currentUser);
  };

  // TODO: remove method when all buttons in sidenav have valid links
  missingRoute = () => {
    console.warn('This button needs to be updated to include a valid route');
  };
}
